import { Field } from "./Field";
import { ProductObject, ProductReference } from "./Product";

export interface Form {
    id?: ID;
    organizerOnly: boolean;
    seller: { id: ID };
    fields: Field[];
    product?: ProductReference;
    productType: ProductObject;
    optionalSourcesList?: FormSource[];
    user?: { id: ID };
}

export enum FormSource {
    XOLA = "xola",
    PLUGIN = "plugin",
}
